/**
 * Thin client for blackjack_gm session APIs (Option B).
 */
import { ARCADE, API_PATH_PROXY_ENABLED } from '../../../utils/config';
import { acquireGmLease, endGmSession, noteGmState } from '../gmLease';

/** Lease key for this game's shared GM (game_engines/gm_registry.py). */
export const GM_GAME_ID = 'blackjack';

export const BLACKJACK_GM_BASE = API_PATH_PROXY_ENABLED
    ? (ARCADE.blackjack?.API_BASE || '')
    : '/blackjack';

async function parseJson(res) {
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(data.error || `Blackjack GM HTTP ${res.status}`);
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return noteGmState(GM_GAME_ID, data);
}

export async function createBlackjackSession() {
    await acquireGmLease(GM_GAME_ID);
    const res = await fetch(`${BLACKJACK_GM_BASE}/session/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: '{}',
    });
    return parseJson(res);
}

export async function moveBlackjackSession(sessionId, { action, bet } = {}) {
    const body = { action };
    if (bet != null) body.bet = bet;
    const res = await fetch(`${BLACKJACK_GM_BASE}/session/${sessionId}/move`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });
    return parseJson(res);
}

export async function deleteBlackjackSession(sessionId) {
    if (!sessionId) return;
    endGmSession(GM_GAME_ID, sessionId);
    try {
        await fetch(`${BLACKJACK_GM_BASE}/session/${sessionId}/delete`, { method: 'POST' });
    } catch {
        /* best-effort */
    }
}

export const WIN_POINTS = 40;
export const BLACKJACK_POINTS = 70;
export const PUSH_POINTS = 15;
export const DEFAULT_BET = 10;
export const INITIAL_BANKROLL = 100;

export const roundScoreGain = (result) => {
    if (result === 'player_blackjack') return BLACKJACK_POINTS;
    if (result === 'player_win') return WIN_POINTS;
    if (result === 'push') return PUSH_POINTS;
    return 0;
};
